import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Feedback from './components/feedback';
import { colors } from 'common/constants';
import { common } from '@mui/material/colors';
import { CampaignContainer } from '../campaign-overview/campaign-container';
import Summary from './components/summary';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

export function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CampaignDataAnalysis() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <CampaignContainer>
            <Box sx={{ width: '20%', mx: 'auto' }}>
                <Tabs
                    centered
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        border: `1px solid ${colors.main}`,
                        backgroundColor: (theme) => theme.palette.common.white,
                        borderRadius: '50px',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: '700',
                            color: colors.main,
                        },
                        '& .Mui-selected': {
                            color: `${common.white} !important`,
                            fontWeight: '700',
                            backgroundColor: colors.main,
                            borderRadius: '50px',
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                    }}
                >
                    <Tab
                        label="Tổng kết"
                        {...a11yProps(0)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                    <Tab
                        label="Phản hồi"
                        {...a11yProps(1)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {value === 0 && <Summary />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                {value === 1 && <Feedback />}
            </CustomTabPanel>
        </CampaignContainer>
    );
}
